(function (w, $) {

    const cookie = (w.cms && w.cms.cookie) || $.cookie;

    $(function() {
        cookie('selectedDeliveryAddressId', null);
        setupNewsletterChangeListener();
    });

    function setupNewsletterChangeListener() {
        const $cbxReceiveNewsletter = $('#cbxReceiveNewsletter');

        if ($cbxReceiveNewsletter.length) {
            const orderId = $cbxReceiveNewsletter.data('orderid');

            if (orderId && orderId !== '0') {
                $cbxReceiveNewsletter.change(function () {
                    $.publicFetch({
                        handler: 'UserData',
                        data: { a: 'SaveNewsletterSubscription', isRecipient: $(this).prop('checked'), orderId: orderId },
                        type: 'POST'
                    });
                });
            }
        }
    };
})(window, jQuery);